import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Button, Tag, Typography, Spin, message, Avatar, List } from 'antd';
import { MessageOutlined, StarOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { expertsApi } from '../services/api';

const { Title, Paragraph, Text } = Typography;

const DetailCard = styled(Card)`
  margin-bottom: 24px;
`;

const expertTypes = [
  { code: 'distribution', name: '发行专家', icon: '📤' },
  { code: 'data', name: '数据专家', icon: '📊' },
  { code: 'marketing', name: '营销专家', icon: '📢' },
  { code: 'creation_audio', name: '音频创作专家', icon: '🎵' },
  { code: 'creation_video', name: '视频创作专家', icon: '🎬' },
  { code: 'creation_image', name: '图片创作专家', icon: '🖼️' },
  { code: 'planning', name: '策划专家', icon: '📋' },
];

function ExpertDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [expert, setExpert] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchExpertDetail();
  }, [id]);

  const fetchExpertDetail = async () => {
    try {
      setLoading(true);
      const res = await expertsApi.getExpertDetail(id);
      setExpert(res.data.data);
    } catch (error) {
      console.error('获取专家详情失败:', error);
      message.error('获取专家详情失败');
    } finally {
      setLoading(false);
    }
  };

  const handleSummon = () => {
    navigate(`/expert-chat/${id}`);
  };

  const getTypeName = (code) => {
    const type = expertTypes.find(t => t.code === code);
    return type ? type.name : code;
  };

  const getTypeIcon = (code) => {
    const type = expertTypes.find(t => t.code === code);
    return type ? type.icon : '👤';
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!expert) {
    return (
      <div style={{ textAlign: 'center', padding: '100px' }}>
        <Title level={4}>专家不存在</Title>
      </div>
    );
  }

  return (
    <div>
      <DetailCard>
        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 24 }}>
          <Avatar size={100} style={{ fontSize: 50, marginRight: 24, background: '#f0f0f0' }}>
            {getTypeIcon(expert.type)}
          </Avatar>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <Title level={3} style={{ margin: 0 }}>{expert.name}</Title>
              <Tag>{getTypeName(expert.type)}</Tag>
            </div>
            <Paragraph style={{ marginBottom: 16 }}>{expert.bio}</Paragraph>
            <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
              <Text type="secondary">
                <StarOutlined /> {expert.rating} 分
              </Text>
              <Text type="secondary">
                {expert.consultationCount} 次服务
              </Text>
            </div>
          </div>
          <Button type="primary" size="large" icon={<MessageOutlined />} onClick={handleSummon}>
            召唤专家
          </Button>
        </div>

        <Title level={5}>擅长领域</Title>
        <div style={{ marginBottom: 24 }}>
          {expert.capabilities.map((cap, idx) => (
            <Tag key={idx} color="blue" style={{ marginBottom: 8, fontSize: 14, padding: '4px 12px' }}>
              {cap}
            </Tag>
          ))}
        </div>

        <Title level={5}>服务案例</Title>
        <List
          dataSource={expert.cases}
          renderItem={(item) => (
            <List.Item>
              <Card size="small" title={item.title} style={{ width: '100%' }}>
                {item.description}
              </Card>
            </List.Item>
          )}
        />
      </DetailCard>
    </div>
  );
}

export default ExpertDetail;
